import { defineComponent as _defineComponent } from 'vue'
import BKButton from '@/components/AppShared/BKButton.vue'
import ProfileDancerCard from '@/components/Profile/ProfileDancerCard.vue'
import { UserDB } from '@/enitites/user'
import { ref } from 'vue'
import { useCloned } from '@vueuse/core'
import OnboardingFormLayout from './OnboardingFormLayout.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingCardForm',
  props: {
    currentStep: { default: 0 },
    error: { default: '' },
    loading: { type: Boolean, default: false },
    steps: { default: 0 },
    user: null
  },
  emits: ["goBack", "submitForm"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'goBack'): void
  (e: 'submitForm', value: UserDB): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { currentStep: number, error: string, loading: boolean, steps: number, user: UserDB };




const user = ref(useCloned(props.user).cloned)
const avatarUrl = ref('')

function avatarLoaded(url: string) {
  avatarUrl.value = url
}

return { __sfc: true,props, emit, user, avatarUrl, avatarLoaded, BKButton, ProfileDancerCard, OnboardingFormLayout }
}

})